/*eslint-disable*/

import {
  Flex,
  Link,
  List,
  ListItem,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';

export default function Footer() {
  let textColor = useColorModeValue('gray.400', 'white');
  let linkColor = useColorModeValue({ base: 'gray.400', lg: 'white' }, 'white');
  return (
    <Flex
      zIndex="3"
      flexDirection={{
        base: 'column',
        lg: 'row',
      }}
      alignItems={{
        base: 'center',
        xl: 'start',
      }}
      justifyContent="space-between"
      px={{ base: '30px', md: '0px' }}
      pb="30px"
    >
      <Text
        color={textColor}
        textAlign={{
          base: 'center',
          xl: 'start',
        }}
        mb={{ base: '20px', lg: '0px' }}
      >
        {' '}
        &copy; {new Date().getFullYear()}
        <Text as="span" fontWeight="500" ms="4px">
            Control de Inventarios
          {' - '}
          <Link href="https://velasresorts.com/" target="_blank">
            Velas Resorts
          </Link>
        </Text>
      </Text>
      <List display="flex">
        <ListItem
          me={{
            base: '20px',
            md: '44px',
          }}
        >
          <Link
            fontWeight="500"
            color={textColor}
            target="_blank"
            href="https://www.velasresorts.com/blog/"
          >
            Blog
          </Link>
        </ListItem>
        <ListItem
          me={{
            base: '20px',
            md: '44px',
          }}
        >
        {/*   <Link
            fontWeight="500"
            color={textColor}
            target="_blank"
            href="https://api.whatsapp.com/send/?phone=5213222268061&text=Hello!%20I%20want%20more%20information%20about%20your%20resorts%20and%20hotels."
          >
            Contacto
          </Link> */}
        </ListItem>
        <ListItem
          me={{
            base: '20px',
            md: '44px',
          }}
        >
          <Link
            fontWeight="500"
            color={textColor}
            target="_blank"
            href="https://www.velasresorts.com/our-resorts"
          >
            Hoteles
          </Link>
        </ListItem>
      </List>
    </Flex>
  );
}
